import { upperFirst } from 'lodash'

import { proxy } from '@/utils'

import settingsFields from '@/components/services/settings/fields'

export default function(options) {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    mixins: [ proxy({ type: 'object' }) ],

    methods: {
      watchValueHandler() {
        return
      },
      watchProxyHandler() {
        return
      }
    },

    render(h) {
      return h(
        settingsFields(options, { type: 'object' }),
        {
          props: {
            value: this.proxy,
            cols: 2,
            items: [ 'login', 'security_key' ].map(field => {
              return { field }
            })
          },
          on: {
            input: event => {
              this.$emit('input', event)
            }
          }
        }
      )
    }
  }
}
